import { useState } from "react";
import { Collapse, Dropdown } from "@/utils/bootstrap";
import MobileMenuItemTitle from "./MobileMenuItemTitle";
interface Props {
  children: any;
  title: any;
  onSelect: undefined | ((e: any) => void);
  isFooter: boolean;
  isMobile: boolean;
  dropdown?: boolean;
  toggle?: boolean;
}
const MobileDropDown: React.FC<Props> = ({
  children,
  title,
  onSelect,
  isFooter,
  isMobile,
  dropdown = true,
  toggle = true,
}) => {
  const [show, setShow] = useState(!dropdown);
  const dropdownMenuClassName = `dropdown-menu  ${
    dropdown ? " active-dropdown-menu " : "unactive-dropdown-menu"
  }`;
  const handleToggle = () => {
    if (toggle) {
      setShow(!show);
    }
  };
  return (
    <Dropdown onSelect={onSelect} show={show} onToggle={handleToggle}>
      <Dropdown.Toggle
        variant={dropdown ? " default" : undefined}
        style={{ border: "none", width: "100%" }}
      >
        <MobileMenuItemTitle
          title={title}
          rotate={show}
          dropdown={dropdown}
          isFooter={isFooter}
        />
      </Dropdown.Toggle>

      <Dropdown.Menu
        className={`${
          isFooter ? "footer-menu-dropdown" : dropdownMenuClassName
        }`}
      >
        <Collapse
          in={show}
          dimension="height"
          className={isFooter && isMobile ? "footer-menu-collapse-mobile" : ""}
        >
          <div style={{ height: "fit-content" }}>{children}</div>
        </Collapse>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MobileDropDown;
